import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import Button from '@/app/_components/buttons/Button';
import moment from 'moment';

interface Props {
  step: string;
  hasNext: boolean;
  onNext: () => void;
  hasSubmit?: boolean;
}
const OnboardingYear = ({ step, hasSubmit, hasNext, onNext }: Props) => {
  const {
    register,
    control,
    watch,
    formState: { errors },
  } = useFormContext();

  const watchYear = watch('graduation_year', false);

  if (step !== 'YEAR') {
    return null;
  }

  const CURRENT_YEAR = moment(Date.now()).year();

  return (
    <div className="w-full md:w-[430px]">
      <label className="text-white font-hanken text-4xl font-extrabold mb-8 block">
        <span className="text-purple3">Lastly...</span>
        <br />
        what year are you?
      </label>

      <>
        <Controller
          control={control}
          name="graduation_year"
          rules={{
            required: true,
            validate: {
              required: (value) => {
                const matches = value.match(/^[0-9]+$/);
                return (
                  (matches?.length > 0 && value >= CURRENT_YEAR) ||
                  `Please enter a year after ${CURRENT_YEAR}. Only numbers are allowed.`
                );
              },
            },
          }}
          render={() => (
            <div className="relative z-0 w-full mb-5 floating-labels">
              <input
                data-test-id="graduation-year-input"
                {...register('graduation_year')}
                className="pt-3 pb-2 block w-full px-0 mt-0 bg-transparent border-0 border-b opacity-70 border-white appearance-none focus:outline-none focus:ring-0 focus:opacity-100"
                type="text"
                placeholder=" "
                aria-label="Enter your expected graduation year"
              />
              <label
                htmlFor="graduation_year"
                className="absolute duration-300 top-3 -z-1 origin-0 text-white opacity-70 text-sm font-normal"
              >
                Enter your expected graduation year
              </label>
              <p
                className="text-orange py-3 text-sm"
                data-test-id="graduation-year-error"
              >
                {/* @ts-ignore*/}
                {errors?.graduation_year?.message}
              </p>
            </div>
          )}
        />

        {hasNext && (
          <Button
            data-test-id="onboarding-next"
            className="!rounded-full min-w-[200px] my-8"
            variant="primary"
            type="button"
            label="Next"
            onClick={onNext}
            disabled={
              !watchYear ||
              watchYear.length <= 0 ||
              !!errors.graduation_year?.message
            }
          />
        )}
        {hasSubmit && (
          <div className="py-8">
            <Button
              data-test-id="onboarding-next"
              className="!rounded-full min-w-[200px]"
              variant="primary"
              type="submit"
              label={'Next'}
              disabled={
                !watchYear ||
                watchYear.length <= 0 ||
                !!errors.graduation_year?.message
              }
            />
          </div>
        )}
      </>
    </div>
  );
};

export default OnboardingYear;
